import { PermissionLevel } from 'src/types/profilePermission';
import { SystemModules } from 'src/types/systemModules';

export type SystemClaimPermission = {
  [key in SystemModules]: PermissionLevel;
};

export interface Claims extends SystemClaimPermission {
  profileName: string;
  profile: UserProfiles;
  exp: number;
}

export enum UserProfiles {
  Admin = 'GO-COMPLIANCE-SU',
  Administrativo = 'GO-COMPLIANCE-ADMRRHH',
  Conductor = 'GO-COMPLIANCE-DRIVER',
  Inspector = 'GO-COMPLIANCE-IP',
}
